import { service } from "../utils/request";

export function addBrand(data) {
  // 添加品牌
  return service({
    url: "api/shop.Goodsbrand/add",
    method: "post",
    data: data
  });
}

export function BrandList(data) {
  return service({
    url: "api/shop.Goodsbrand/index",
    method: "post",
    data: data
  });
}

export function delBrand(data) {
  // 品牌删除
  return service({
    url: "api/shop.Goodsbrand/del",
    method: "post",
    data: data
  });
}

export function editBrand(data) {
  return service({
    url: "api/shop.Goodsbrand/edit",
    method: "post",
    data: data
  });
}

// api/shop.Shopgoodstags/add
export function addlabel(data) {
  return service({
    url: "api/shop.Shopgoodstags/add",
    method: "post",
    data: data
  });
}

// api/shop.Shopgoodstags/index
export function labelList(data) {
  return service({
    url: "api/shop.shopgoodstags/index",
    method: "post",
    data: data
  });
}

// api/shop.Shopgoodstags/del
export function delLabel(data) {
  return service({
    url: "api/shop.Shopgoodstags/del",
    method: "post",
    data: data
  });
}

// api/shop.Shopgoodstags/edit
export function editLabel(data) {
  return service({
    url: "merch/pc.Shopgoodstags/edit",
    method: "post",
    data: data
  });
}

// api/shop.GoodsTypeSpec/add
export function addAttr(data) {
  return service({
    url: "api/shop.GoodsTypeSpec/add",
    method: "post",
    data: data
  });
}

//api/shop.GoodsTypeSpec/get_item
export function getItemAttr(data) {
  //获取商品属性
  return service({
    url: "api/shop.GoodsTypeSpec/get_item",
    method: "post",
    data: data
  });
}

// api/shop.GoodsTypeSpec/index
export function AttrList(data) {
  // 获取商品属性列表
  return service({
    url: "api/shop.GoodsTypeSpec/index",
    method: "post",
    data: data
  });
}

// api/shop.GoodsTypeSpec/del
export function delAttr(data) {
  return service({
    url: "api/shop.GoodsTypeSpec/del",
    method: "post",
    data: data
  });
}

export function editAttr(data) {
  return service({
    url: "api/shop.GoodsTypeSpec/edit",
    method: "post",
    data: data
  });
}

export function addPara(data) {
  return service({
    url: "api/shop.ShopGoodsParams/add",
    method: "post",
    data: data
  });
}

export function ParaList(data) {
  return service({
    url: "api/shop.ShopGoodsParams/index",
    method: "post",
    data: data
  });
}

export function delPara(data) {
  return service({
    url: "api/shop.ShopGoodsParams/del",
    method: "post",
    data: data
  });
}

export function editPara(data) {
  return service({
    url: "api/shop.ShopGoodsParams/edit",
    method: "post",
    data: data
  });
}

export function addClass(data) {
  return service({
    url: "api/shop.Goodscate/add",
    method: "post",
    data: data
  });
}

export function ClassList(data) {
  // 分类列表
  return service({
    url: "api/shop.Goodscate/index",
    method: "post",
    data: data
  });
}

export function delClass(data) {
  // 分类删除
  return service({
    url: "api/shop.Goodscate/del",
    method: "post",
    data: data
  });
}

export function hierarchy(data) {
  // 分类层级
  return service({
    url: "api/shop.Shopgoodscatelevel/add",
    method: "post",
    data: data
  });
}

export function getlevel(data) {
  // 获取分类层级
  return service({
    url: "api/shop.Shopgoodscatelevel/getlevel",
    method: "post",
    data: data
  });
}

export function ClassEdit(data) {
  // 获取分类层级
  return service({
    url: "api/shop.Goodscate/edit",
    method: "post",
    data: data
  });
}

export function addType(data) {
  // 添加类型
  return service({
    url: "api/shop.GoodsType/addnew",
    method: "post",
    data: data
  });
}

export function TypeList(data) {
  // 获取类型
  return service({
    url: "api/shop.GoodsType/indexnew",
    method: "post",
    data: data
  });
}

export function delType(data) {
  // 删除类型
  return service({
    url: "api/shop.GoodsType/delnew",
    method: "post",
    data: data
  });
}

export function Getspec(data) {
  // 获取多规格
  return service({
    url: "api/shop.GoodsType/getspec",
    method: "post",
    data: data
  });
}

export function getComList(data) {
  // 获取商品列表
  return service({
    url: "goods/agent.goods/index",
    method: "post",
    data: data
  });
}
export function editType(data) {
  // 获取商品属性
  return service({
    url: "api/shop.GoodsType/editnew",
    method: "post",
    data: data
  });
}
// api/shop.GoodsTypeSpec/get_item
// export function getItemAttr(data) {
//   // 获取商品属性
//   return service({
//     url: "api/shop.GoodsTypeSpec/get_item",
//     method: "post",
//     data: data
//   });
// }

export function addPoduct(data) {
  // 添加商品
  return service({
    url: "goods/agent.goods/addGoods",
    method: "post",
    data: data
  });
}
export function addImage(data) {
  //上传图片
  return service({
    url: "api/Upload/uploads",
    method: "post",
    data: data
  });
}
export function TypeAddImage(data, onUploadProgress) {
  //上传图片
  return service({
    url: "api/Upload/uploads",
    method: "post",
    data: data,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    onUploadProgress
  });
}
export function addVideo(data) {
  //上传视频
  return service({
    url: "api/Upload/uploadvideo",
    method: "post",
    data: data
  });
}
export function acquireProduct(data) {
  //获取单个商品详情
  return service({
    url: "goods/agent.goods/detail",
    method: "post",
    data: data
  });
}
export function deleteProduct(data) {
  //删除商品
  return service({
    url: "goods/agent.goods/del",
    method: "post",
    data: data
  });
}
export function editProduct(data) {
  //编辑商品
  return service({
    url: "goods/agent.goods/editGoods",
    method: "post",
    data: data
  });
}
export function Addgroup(data) {
  //添加分组
  return service({
    url: "merch/agent.Goodsgroup/add",
    method: "post",
    data: data
  });
}
export function groupList(data) {
  //获取分组列表
  return service({
    url: "merch/agent.Goodsgroup/index",
    method: "post",
    data: data
  });
}
export function groupDel(data) {
  //添加分组
  return service({
    url: "merch/agent.Goodsgroup/del",
    method: "post",
    data: data
  });
}
// api/shop.Goodsgroup/edit编辑分组
export function groupEdit(data) {
  //添加分组
  return service({
    url: "merch/agent.Goodsgroup/edit",
    method: "post",
    data: data
  });
}
//属性
export function getAddAttrApi(data) {
  //增加商品属性接口
  return service({
    url: "api/shop.shopgoodssearchattr/add",
    method: "post",
    data: data
  });
}
export function getAttrNameApi(data) {
  //获取商品属性名称接口
  return service({
    url: "api/shop.shopgoodssearchattr/index",
    method: "post",
    data: data
  });
}
export function getAttrValueApi(data) {
  //获取商品属性值接口
  return service({
    url: "api/shop.shopgoodssearchattrrel/index",
    method: "post",
    data: data
  });
}
export function getAddAttrValueApi(data) {
  //增加商品属性值接口
  return service({
    url: "api/shop.shopgoodssearchattrrel/add",
    method: "post",
    data: data
  });
}
//neibu参数
export function getInnerAttrNameApi(data) {
  //内部属性列表
  return service({
    url: "api/shop.shopgoodsinnerattr/index",
    method: "post",
    data: data
  });
}
export function getInnerAttrValueApi(data) {
  //内部属性值列表
  return service({
    url: "api/shop.shopgoodsinnerattrrel/index",
    method: "post",
    data: data
  });
}
export function getAddInnerAttrApi(data) {
  //添加内部属性名
  return service({
    url: "api/shop.shopgoodsinnerattr/add",
    method: "post",
    data: data
  });
}
export function getAddInnerAttrValueApi(data) {
  //添加内部属性值
  return service({
    url: "api/shop.shopgoodsinnerattrrel/add",
    method: "post",
    data: data
  });
}
// 属性end

// canshu
export function getParamNameApi(data) {
  //参数列表
  return service({
    url: "api/shop.shopgoodssearchparams/index",
    method: "post",
    data: data
  });
}
export function getParamValueApi(data) {
  //参数值列表
  return service({
    url: "api/shop.shopgoodssearchparamsrel/index",
    method: "post",
    data: data
  });
}
export function getAddParamApi(data) {
  //添加参数名
  return service({
    url: "api/shop.shopgoodssearchparams/add",
    method: "post",
    data: data
  });
}
export function getAddParamValueApi(data) {
  //添加参数值
  return service({
    url: "api/shop.shopgoodssearchparamsrel/add",
    method: "post",
    data: data
  });
}
//canshu end
// 服务star
export function getServeNameApi(data) {
  //服务列表
  return service({
    url: "api/shop.shopgoodsservice/index",
    method: "post",
    data: data
  });
}
export function getServeValueApi(data) {
  //服务值列表
  return service({
    url: "api/shop.shopgoodsservicerel/index",
    method: "post",
    data: data
  });
}
export function getAddServeApi(data) {
  //添加服务名
  return service({
    url: "api/shop.shopgoodsservice/add",
    method: "post",
    data: data
  });
}
export function getAddServeValueApi(data) {
  //添加服务值
  return service({
    url: "api/shop.shopgoodsservicerel/add",
    method: "post",
    data: data
  });
}
// new
export function getServeDetail(data) {
  //代理端服务信息
  return service({
    url: "api/shop.shopgoodsservice/detail",
    method: "post",
    data: data
  });
}
export function getServeEdit(data) {
  //代理端编辑服务信息
  return service({
    url: "api/shop.shopgoodsservice/editnew",
    method: "post",
    data: data
  });
}
export function getServeDel(data) {
  //删除
  return service({
    url: "api/shop.shopgoodsservice/del",
    method: "post",
    data: data
  });
}
// 服务end
// 分组子集
export function groupChild(data) {
  //分组子集
  return service({
    url: "api/shop.Goodsgroup/getchild",
    method: "post",
    data: data
  });
}
// 获取商品标签
export function getLabeldataApi(data) {
  return service({
    url: "api/shop.shopgoodstags/index",
    method: "post",
    data: data
  });
}
// 添加商品标签
export function getAddLabeldataApi(data) {
  return service({
    url: "api/shop.shopgoodstags/add",
    method: "post",
    data: data
  });
}
// 获取总商品分类
export function getCateApi(data) {
  return service({
    // url: "api/shop.Goodscate/get_cate",
    url: "shop/agent.Goodscate/index",
    method: "post",
    data: data
  });
}
// 商品上下架
export function shelvesApi(data) {
  return service({
    url: "goods/agent.goods/setMarketable",
    method: "post",
    data: data
  });
}

/**商家分类 */
export function getShopGoodsList(data) {
  return service({
    url: "shop/agent.Goodscate/index",
    method: "post",
    data: data
  });
}
// 删除分类
export function deleteShopSorts(data) {
  return service({
    url: "shop/agent.Goodscate/del",
    method: "post",
    data: data
  });
}
// 添加分类
export function addShopSorts(data) {
  return service({
    url: "shop/agent.Goodscate/add",
    method: "post",
    data: data
  });
}
// 修改分类
export function editShopSorts(data) {
  return service({
    url: "shop/agent.Goodscate/edit",
    method: "post",
    data: data
  });
}
// // 获取分类详情信息
export function getDeatil(data) {
  return service({
    url: "shop/agent.Goodscate/detail",
    method: "post",
    data: data
  });
}

// 筛选详情
export function cateDetail(data) {
  return service({
    url: "shop/agent.Shopsearchgroup/detail",
    method: "post",
    data: data
  });
}

// 筛选项列表
export function getGoodscate(data) {
  return service({
    url: "shop/agent.Shopsearchgroup/index",
    method: "post",
    data: data
  });
}
// 添加筛选项
export function addGoodscate(data) {
  return service({
    url: "shop/agent.Shopsearchgroup/add",
    method: "post",
    data: data
  });
}
// 删除筛选项
export function delGoodscate(data) {
  return service({
    url: "shop/agent.Shopsearchgroup/del",
    method: "post",
    data: data
  });
}
//修改筛选项
export function editGoodscate(data) {
  return service({
    url: "shop/agent.Shopsearchgroup/edit",
    method: "post",
    data: data
  });
}
// 筛选详情分组
export function getGoodscateDeatil(data) {
  return service({
    url: "shop/agent.Shopsearchgroup/detail",
    method: "post",
    data: data
  });
}

// 排行榜设置
export function rankSetingList(data) {
  return service({
    url: "shop/agent.Shoprankset/index",
    method: "post",
    data: data
  });
}
export function rankSetingdetails(data) {
  return service({
    url: "shop/agent.Shoprankset/detail",
    method: "post",
    data: data
  });
}
export function rankSetingedit(data) {
  return service({
    url: "shop/agent.Shoprankset/edit",
    method: "post",
    data: data
  });
}
export function rankSetingadd(data) {
  return service({
    url: "shop/agent.Shoprankset/add",
    method: "post",
    data: data
  });
}
export function rankSetingdel(data) {
  return service({
    url: "shop/agent.Shoprankset/del",
    method: "post",
    data: data
  });
}
